<app-btn-group-nav [pages]="pages" [identifier]="'apiInterface'" (activePageChange)="activePage = $event"></app-btn-group-nav>

<div class="mt-4">
  @if (model()) {
    <router-outlet></router-outlet>
  } @else {
    <app-spinner></app-spinner>
  }
</div>
